// Простейший debounce, чтобы не тянуть lodash в newgen.
export function debounce(fn, wait) {
  let timer = null;
  const debounced = function debounced() {
    const args = arguments;
    const self = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      fn.apply(self, args);
    }, wait);
  };
  debounced.cancel = () => {
    if (timer) { clearTimeout(timer); timer = null; }
  };
  return debounced;
}



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/shared/debounce.js